import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { planLogout, startLoadingPlanes } from '../../actions/planes';
import { setMenuLateral } from '../../actions/ui';
import { AddIcon } from '../../assets/svg/iconos';

const describirProfesionalesIncluidos = (profesionales) =>
    profesionales === 1 ? '1 profesional' : `${profesionales} profesionales`;

export const Planes = ({ history }) => {

    const dispatch = useDispatch();
    const { planes } = useSelector(state => state.planes);
    const { colores } = useSelector(state => state.ui);

    const planesActivos = useMemo(() => planes.filter(plan => !plan.deleted), [planes]);

    useEffect(() => {
        dispatch(setMenuLateral('planes'));
        dispatch(startLoadingPlanes());

        return () => {
            dispatch(planLogout());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const clickAdd = () => {
        history.push({
            pathname: `/plan/new`
        });
    };

    const editPlan = (plan) => {
        history.push({
            pathname: `/plan/${plan._id}`,
            state: {
                plan
            }
        });
    };

    return (
        <div
            className='empresas'
            style={{
                '--colorPrincipal': colores.colorPrincipal,
                '--colorSecundario': colores.colorSecundario,
                '--color3': colores.color3,
                '--color4': colores.color4,
                '--color5': colores.color5,
                '--color6': colores.color6,
                '--color7': colores.color7,
            }}
        >
            <div className="preheader">
                <div className="title">
                    <h1 style={{ color: colores.colorPrincipal }}>Planes</h1>
                </div>
                <div className="botonera">
                    <div
                        className="btn-add"
                        style={{ backgroundColor: colores.color6, color: colores.colorPrincipal }}
                        onClick={ clickAdd }
                    >
                        <div className='icono'>
                            <AddIcon color={ colores.colorPrincipal } />
                        </div>
                    </div>
                </div>
            </div>
            <div className='planes-list'>
                {
                    planesActivos.map(plan => (
                        <div
                            key={plan._id}
                            className='plan-item'
                            onClick={() => editPlan(plan)}
                        >
                            <div className='plan-header'>
                                {plan.recomendado && <div className='recomendado'>Recomendado</div>}
                                <h5>Plan {plan.nombre}</h5>
                            </div>
                            <div className='plan-body'>
                                <div className='plan-feature'>
                                    <div className='plan-check'><div className='plan-check-item'></div></div>
                                    <p>{describirProfesionalesIncluidos(plan.profesionales)}</p>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    );
}
